<template>
  <div class="with-dropdown" v-if="archivedDesigns.length > 0">
    <roe-modal wrap-class="drop-down-menu" ref="dropdown">
      <div class="drop-down-sub-menu">
        <div class="light-label">Available designs</div>
        <ul>
          <li v-for="design in archivedDesigns">
            <span
              @click="
                canAddCurrentDesign();
                unarchive(design);
                $refs.dropdown.close();
              "
              >{{ design.name }}</span
            >
            <button @click="remove(design.id)" class="btn-close"></button>
          </li>
        </ul>
      </div>
      <div class="drop-down-actions">
        <ul>
          <li>
            <button class="btn-link" @click="removeArchived">Delete All</button>
          </li>
        </ul>
      </div>
    </roe-modal>
    <button @click.stop="$refs.dropdown.changeState()" class="btn-secondary">
      Display Archived
    </button>
  </div>
</template>

<script>
import RoeModal from "@/components/_shared/Modal";
import {
  ALTERNATIVE_DESIGN_UNARCHIVE,
  ALTERNATIVE_DESIGN_REMOVE,
  ALTERNATIVE_DESIGNS_REMOVE_ARCHIVED
} from "@/store/actions.type";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "RoeArchivedDesigns",
  components: { RoeModal },
  props: {
    canAddCurrentDesign: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters(["archivedDesigns"])
  },
  methods: {
    ...mapActions({
      unarchive: ALTERNATIVE_DESIGN_UNARCHIVE,
      remove: ALTERNATIVE_DESIGN_REMOVE,
      removeArchived: ALTERNATIVE_DESIGNS_REMOVE_ARCHIVED
    })
  }
};
</script>
